module.exports = __webpack_public_path__ + "img/icon_btn_withdraw@2x.cf778feb.png";